import { create, w, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createNlsMiddleware } from 'lcc-state';
import { getScoreStyle } from '@holmescorp/progress-chart';
import { ScoreIcon } from './index';
import css from '../css/progress-view.m.css';
const factory = create({
    nls: createNlsMiddleware('ditabook'),
    theme
}).properties();
export const ScoreToast = factory(({ middleware: { nls, theme }, properties }) => {
    const { messages: { assess_progress_threshold_low = '60', assess_progress_threshold_high = '80' } } = nls();
    const { score, messages, useMidScore = true } = properties();
    const themeCss = theme.classes(css);
    const lowScore = parseInt(assess_progress_threshold_low) || 60;
    const highScore = parseInt(assess_progress_threshold_high) || 80;
    const scoreStyle = getScoreStyle(score, lowScore, highScore, themeCss);
    if (score <= 0) {
        return v('div', { xqa: 'toast-not-started', classes: [themeCss.toast, scoreStyle] }, [
            w(ScoreIcon, { score }),
            messages?.none
        ]);
    }
    if (score < lowScore) {
        return v('div', { xqa: 'toast-low-score', classes: [themeCss.toast, scoreStyle] }, [
            w(ScoreIcon, { score }),
            messages?.low
        ]);
    }
    if (score < highScore && useMidScore) {
        return v('div', { xqa: 'toast-mid-score', classes: [themeCss.toast, scoreStyle] }, [
            w(ScoreIcon, { score }),
            messages?.mid
        ]);
    }
    return v('div', { xqa: 'toast-high-score', classes: [themeCss.toast, scoreStyle] }, [
        w(ScoreIcon, { score }),
        messages?.high
    ]);
});
export default ScoreToast;
